import React from 'react';

import {
  Alert,
  Grid,
  DescriptionList,
  DescriptionItem,
  Section,
  SidePage,
  Divider,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { CampaignDetails } from 'scenes/Campaigns/GGCampaigns/components/CampaignDetails';

export const DummyCampaignSidePage = ({
  open,
  onClose,
  onExited,
  campaign,
  ...props
}) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleOpenCampaign = (id) => {
    openChildComponent(CampaignDetails, { id });
  };

  const handleClose = () => {
    onClose();
    props.onSubmit && props.onSubmit();
  };

  return (
    <SidePage
      open={open}
      onClose={handleClose}
      onExited={onExited}
      backdrop={false}
      {...props}
    >
      <SidePage.Title title={'New Campaigns Details'} />
      <SidePage.NewBody wrapper={true} dense={true}>
        <SidePage.NewContent withSidebar={false}>
          <Section>
            <Alert severity={'success'}>Campaign created</Alert>
          </Section>
          <Divider />
          <Section title={'Campaign'}>
            <DescriptionList
              data={campaign}
              stripEmpty={true}
              disableGutters={true}
            >
              <DescriptionItem label={'ID'} field={'id'} />
              <DescriptionItem
                label={'Name'}
                field={'name'}
                type={'link'}
                onValueClick={() => handleOpenCampaign(campaign.id)}
              />
            </DescriptionList>
          </Section>
          <Divider />
        </SidePage.NewContent>
        {childComponent}
      </SidePage.NewBody>
      <SidePage.Actions>
        <Grid container justifyContent={'space-between'}>
          <SidePage.CloseButton />
        </Grid>
      </SidePage.Actions>
    </SidePage>
  );
};
